import { Link } from 'react-router';
import { ArrowRight, Landmark } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DataLoader } from '@/components/ui/DataLoader';
import { useCarryFunds } from '@/portal/carry/hooks/useCarry';
import type { FundMemberFund } from '@/types/fundMember';

function activeFundNames(funds: FundMemberFund[]): string[] {
  return funds
    .filter((fund) => fund.status === 'ACTIVE')
    .map((f) => f.fund_name);
}

export function FundCarrySection() {
  const fundsQuery = useCarryFunds();
  const hasActiveFunds = activeFundNames(fundsQuery.data ?? []).length > 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Landmark className="h-5 w-5" />
            Fund carry
          </span>
          {hasActiveFunds && (
            <Link
              to="/portal/carry"
              className="flex items-center gap-1 text-sm font-normal text-muted-foreground hover:text-foreground transition-colors"
            >
              View all
              <ArrowRight className="h-4 w-4" />
            </Link>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <DataLoader<FundMemberFund[]>
          query={fundsQuery}
          showEmptyState={(funds) => activeFundNames(funds).length === 0}
          emptyComponent={
            <p className="text-sm text-muted-foreground py-6 text-center">
              You do not participate in any fund carry yet.
            </p>
          }
        >
          {(funds) => {
            const active = activeFundNames(funds);
            return (
              <p className="text-sm text-foreground">
                Carried interest in{' '}
                <span className="font-medium">{active.length}</span>{' '}
                {active.length === 1 ? 'fund' : 'funds'}: {active.join(', ')}
              </p>
            );
          }}
        </DataLoader>
      </CardContent>
    </Card>
  );
}
